import { Meter as BaseMeter } from '@base-ui/react/meter';
import type { ComponentProps, ReactNode } from 'react';
import { cx } from '../lib/styled.tsx';
import { fieldLabel } from '../lib/surfaces.ts';

export interface MeterProps extends ComponentProps<typeof BaseMeter.Root> {
  label?: ReactNode;
  /** Show the formatted value opposite the label. */
  showValue?: boolean;
}

/**
 * A measurement inside a known range — disk used, quota spent, score.
 *
 * Not {@link Progress}: that one says how far along a task is, this one says how
 * full something already is, and screen readers announce them differently.
 */
export function Meter({ label, showValue, className, ...props }: MeterProps) {
  return (
    <BaseMeter.Root className={cx('flex w-full flex-col gap-2', className)} {...props}>
      {label || showValue ? (
        <div className="flex items-baseline justify-between gap-4">
          {label ? <BaseMeter.Label className={fieldLabel}>{label}</BaseMeter.Label> : null}
          {showValue ? <BaseMeter.Value className="text-sm tabular-nums text-ink-muted" /> : null}
        </div>
      ) : null}
      <BaseMeter.Track className="h-[5px] w-full overflow-hidden rounded-full bg-border-subtle">
        <BaseMeter.Indicator className="h-full rounded-full bg-brand-400 transition-[width] duration-300 ease-out-quint" />
      </BaseMeter.Track>
    </BaseMeter.Root>
  );
}
